import { Action, createAction, props } from '@ngrx/store';

import { ScanFlowRegistrationData } from 'app/features/scan-flow/state/scan-flow/scan-flow.reducer';

export const sendCurrentScanFlowRegistrationData = createAction(
    '[ScanFlow] Send Current Registration Data',
    props<{
        registrationTimestamp: number;
    }>(),
);

export const sendTransformedScanFlowRegistrationData = createAction(
    '[ScanFlow] Send Transformed Registration Data',
    props<{
        onSuccessAction: Action | undefined;
        registrationData: ScanFlowRegistrationData;
        registrationTimestamp: number;
    }>(),
);

export const sendTransformedScanFlowRegistrationDataSuccess = createAction(
    '[ScanFlow] Send Transformed Registration Data Success',
    props<{ registrationData: ScanFlowRegistrationData }>(),
);

export const scheduleScanFlowRegistration = createAction(
    '[ScanFlow] Schedule Registration',
    props<{ scheduledRegistrationDate: number | undefined }>(),
);

export const cancelScheduledScanFlowRegistration = createAction('[ScanFlow] Cancel Scheduled Registration');
